import React from 'react'

const WishList = () => {
  return (
    <h1>WishList</h1>
  )
}

export default WishList